import display from './display/routes'
import general from './general/routes'

const settingRoutes = {
  index: {
    path: 'index.setting',
    url: 'options',
  },
  display,
  general,
}

export default settingRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/routes.js